/**
 * Contains Vuex Store Methods
*/
import Vue from 'vue';
import Vuex from 'vuex';

import Forms from "../apis/Forms"
import Courses from "../apis/Courses";
import User from "../apis/User";
import Moodle from "../apis/Moodle";
import Customers from "../apis/Customers";
import CustomerSubscription from "../apis/CustomerSubscription";
import UserCustomerSubscription from '../apis/UserCustomerSubscription';
import CustomerInstance from '../apis/CustomerInstance';
import Product from "../apis/Product";
import StripeApi from "../apis/StripeApi";
import Common from "../functions/index";
import Constants from "../constants/index";
import WebShop from '../apis/WebShop';
import WebShopPayment from "../apis/WebShopPayment";
import Coupon from '../apis/Coupon';
import Settings from "../apis/Settings";
import StripeConnectAccount from "../apis/StripeConnectAccount";
import Stripe from "../apis/Stripe";
import CoursesEventInquiry from '../apis/CoursesEventInquiry';

import Completions from "../apis/Completions";
import Licenses from "../apis/Licenses";
import Certificates from "../apis/Certificates";
import CourseAssignment from '../apis/CourseAssignment';
import WebShopPaymentCharge from '../apis/WebShopPaymentCharge';
import Api from '../apis/Api';
import CustomersSettings from '../apis/CustomersSettings';
import Company from '../apis/Company';
import Subscription from '../apis/Subscription';

import TemporaryWebshopOrder from '../apis/TemporaryWebshopOrder';

const words = require("naughty-words");

Vue.use(Vuex);

export const store = new Vuex.Store({
    /**
     * State variables which keeps track of all the data needs for the application
    */
    state: {

        APIbaseURL: process.env.VUE_APP_API_BASE_URL,
        storageBaseURL: process.env.VUE_APP_STORAGE_BASE_URL,
        spInstanceURL: (typeof window === 'undefined') ? "" : window.location.origin + '/',
        spInstanceVueURL: (typeof window === 'undefined') ? process.env.BASE_URL : window.location.origin + process.env.BASE_URL,
        contentLoadingState: false,
        applogo: null,
        publicRoutes: ['userSignupForm', 'Login', 'RequestPasswordReset', 'CompanyMakePayment', 'CompanyMakePaymentSuccess', 'CompanyMakePaymentFail', 'WebShopPublic', 'CompanyWebshopPayment', 'CompanyWebshopPaymentSuccess', 'CompanyWebshopPaymentFail', 'ContinueCompanyWebshopPayment'],
        headerHiddenPublicRoutes: ['WebShopPublic'],
        noMPPublicRoutes: ['WebShopPublic'],
        webshopCourseId: "prod_L58yvxgoILjhyx",
        authUser: null,
        authUserRoles: [],
        signUpForms: null, //{ name: "Customer Name 1", id: 1 }
        userSignupForm: null,
        users: null,
        managers: null,
        teamLeads: null,
        instructors: null,
        students: null,
        completions: null,
        licenses: null,
        certificates: null,
        coupons: [],
        courses: [],
        customers: [],
        customerSettings: [],
        customer: null,
        naughtyList: [],
        domains: [],
        subscription: [],
        customerSubscription: null,
        userCustomerSubscription: null,
        generalSettings: [],
        subscriptions: [],
        allSettings: [],
        formTitles: {
            1: Constants.form_title_create_new_form,
            2: Constants.form_title_custom_signup_page,
            3: Constants.form_title_share_link,
        },
        selectedProduct: null,
        courseTypes: [
            { type_id: 'elearning', type_name: "E-learning" },
            // { type_id: 'blended', type_name: "Blended" },
            { type_id: 'instructor_led_training', type_name: "Instructor-led" }
        ],
        webshopCurrencies: [
            { currency_id: 'SEK', currency_name: "SEK" },
            { currency_id: 'EUR', currency_name: "EUR" },
            { currency_id: 'USD', currency_name: "USD" }
        ],
        nonMandatoryFields: [
            {
                value: 5,
                label: "",
                text: "Mobile Phone",
                mandatory: 0,
                fields: [
                    {
                        label: "Mobile Phone",
                        placeholder: "Enter the mobile phone",
                        type: "text",
                        value: "val",
                        mandatory: 0,
                    },
                ],
            },
            {
                value: 6,
                label: "",
                text: "Home Phone",
                mandatory: 0,
                fields: [
                    {
                        label: "Home Phone",
                        placeholder: "Enter the Home Phone Number",
                        type: "text",
                        value: "val",
                        mandatory: 0,
                    },
                ],
            },
            {
                value: 7,
                label: "Organization Affiliation",
                text: "Organization Affiliation",
                mandatory: 0,
                fields: [
                    {
                        label: "Company name",
                        placeholder: "Enter Company Name",
                        type: "textarea",
                        value: "val",
                        mandatory: 0,
                        id: 1,

                    },
                    {
                        label: "Address",
                        placeholder: "Enter Company Address",
                        type: "text",
                        value: "val",
                        mandatory: 0,
                        id: 2,
                    },
                    {
                        label: "Zip Code",
                        placeholder: "Enter Company ZIP Code",
                        type: "text",
                        value: "val",
                        mandatory: 0,
                        id: 3,
                    },
                    {
                        label: "Location",
                        placeholder: "Enter Company Location",
                        type: "text",
                        value: "val",
                        mandatory: 0,
                        id: 4,
                    },
                    {
                        label: "Billing Code",
                        placeholder: "Enter Company Billing Code",
                        type: "text",
                        value: "val",
                        mandatory: 0,
                        id: 5
                    },
                    {
                        label: "Employment Number",
                        placeholder: "Enter Company Employment Number",
                        type: "text",
                        value: "val",
                        mandatory: 0,
                        id: 6
                    },
                ],
            },
            {
                value: 8,
                label: "",
                text: "Order Certificate",
                mandatory: 0,
                fields: [
                    {
                        label: "Order Certificate",
                        placeholder: "I want to order a certificate",
                        type: "checkbox",
                        value: "val",
                        mandatory: 0,
                    },
                ],
            },
            /*{
                value: 9,
                label: "Organization Affiliation (Custom)",
                text: "Organization Affiliation (Custom)",
                mandatory: 0,
                fields: [
                    {
                        label: "Company List",
                        placeholder: "Enter company names (one name per line)",
                        selectionplaceholder: "Select company",
                        inputplaceholder: "Company name",
                        type: "textarea",
                        value: "val",
                        mandatory: 0,
                        id: 1,
                        instructions: "Enter details for companies as line by line with the format of Company Name | Address | Zip Code | Location | Billing Code"
                    },
                    {
                        label: "Employment Number",
                        placeholder: "Enter Company Employment Number",
                        type: "text",
                        value: "val",
                        mandatory: 0,
                        id: 2
                    },
                ],
            },*/
        ],
        mandatoryFields: [
            {
                value: 1,
                label: "",
                text: "First Name",
                mandatory: 1,
                fields: [
                    {
                        label: "First Name",
                        placeholder: "Enter the First Name",
                        type: "text",
                        value: "val",
                        mandatory: 1,
                    },
                ],
            },
            {
                value: 2,
                label: "",
                text: "Last Name",
                mandatory: 1,
                fields: [
                    {
                        label: "Last Name",
                        placeholder: "Enter the Last Name",
                        type: "text",
                        value: "val",
                        mandatory: 1,
                    },
                ],
            },
            {
                value: 3,
                label: "",
                text: "Email",
                mandatory: 1,
                fields: [
                    {
                        label: "Email",
                        placeholder: "Enter the email",
                        type: "email",
                        value: "val",
                        mandatory: 1,
                    },
                ],
            },
            {
                value: 4,
                label: "",
                text: "Password",
                mandatory: 1,
                fields: [
                    {
                        label: "Password",
                        placeholder: "Enter Password",
                        type: "password",
                        value: "val",
                        mandatory: 1,
                    },
                ],
            },
        ],

        routeData: {
            'CompanyAccountSubscription': {
                'authorizedUserRoles': [10, 16, 18]
            },
            'CompanyAccountProfile': {
                'authorizedUserRoles': [10, 16, 18]
            },
            'CompanyAccountSignupForms': {
                'authorizedUserRoles': [10, 16, 18]
            },
            'CompanyAccountWebShop': {
                'authorizedUserRoles': [10, 16, 18]
            }
        },

        currentAbandonedOrder: null,
        companies: [],
    },
    /**
     * Getter functions which allows to return values from the state variables
    */
    getters: {
        constants: state => {
            return state.constants;
        },
        getAuthUser: state => {

            let authUser = state.authUser;

            if (authUser == null) {
                authUser = Common.getFromLocalStorage(Constants.auth_user, true);
            }

            return authUser;
        },
        getAuthUserRoles: (state) => {
            return state.authUserRoles
        },
        routeData: (state) => {
            return state.routeData;
        },
        sampleFunction: state => {
            // passing the variable 
            var data = state.courses;

            data = state.courses.map(c => {
                return {
                    name: c.name,
                    code: c.code,
                }
            });
            return data;

            // How to use it, within computations section
            // return this.$store.getters.sampleFunction;
        },
        allPublicRoutes: state => {
            return state.publicRoutes;
        },
        allHeaderHiddenPublicRoutes: state => {
            return state.headerHiddenPublicRoutes;
        },
        allNoMPPublicRoutes: state => {
            return state.noMPPublicRoutes;
        },
        instanceUrl: state => {
            return state.spInstanceURL;
        },
        storageUrl: state => {
            return state.storageBaseURL;
        },
        contentLoading: state => {
            return state.contentLoadingState;
        },
        applogo: state => {
            return state.applogo;
        },
        allSignUpForms: state => {

            return state.signUpForms;
        },
        signUpFormById: (state) => (id) => {

            let form = state.signUpForms.filter(function (e) {
                return e.id == id;
            });

            return form;

        },

        allCustomers: state => {
            return state.customers;
        },

        customerSettings: state => {
            return state.customerSettings;
        },

        coupons: state => {
            return state.coupons;
        },

        customer: state => {
            return state.customer;
        },

        getNaughtyList: state => {
            return state.naughtyList;
        },

        getDomains: state => {
            return state.domains;
        },

        customerSubscription: state => {
            return state.customerSubscription;
        },
        userCustomerSubscription: state => {
            return state.userCustomerSubscription;
        },
        completions: state => {
            return state.completions;
        },
        licenses: state => {
            return state.licenses;
        },
        certificates: state => {
            return state.certificates;
        },
        users: state => {
            return state.users;
        },
        managers: state => {
            return state.managers;
        },
        teamLeads: state => {
            return state.teamLeads;
        },
        instructors: state => {
            return state.instructors;
        },
        students: state => {
            return state.students;
        },
        courses: state => {
            return state.courses;
        },
        spInstanceVueURL: state => {
            return state.spInstanceVueURL;
        },
        courseTypes: state => {
            return state.courseTypes;
        },
        webshopCourseId: state => {
            return state.webshopCourseId;
        },

        generalSettings: state => {
            return state.generalSettings;
        },

        subscriptions: state => {
            return state.subscriptions;
        },

        allSettings: state => {
            return state.allSettings;
        },
        webshopCurrencies: state => {
            return state.webshopCurrencies;
        },
        currentAbandonedOrder: state => {
            return state.currentAbandonedOrder;
        },
        allCompanies: state => {
            return state.companies;
        }
    },
    /**
     * Mutation methods which allows to update the state variables
    */
    mutations: {
        setAuthUser: (state, payload) => {
            Common.setinLocalStorage(Constants.auth_user, payload, true);
            state.authUser = payload;
        },
        setAuthUserRoles: (state, payload) => {
            state.authUserRoles = payload;
        },
        contentLoading: (state, payload) => {
            state.contentLoadingState = payload;
        },
        applogo: (state, payload) => {

            state.applogo = payload;
        },
        sampleFunction: (state) => {
            // passing the variable 
            state.courses.map(c => {
                c.name + " mutated",
                    c.code + "_mutated"
            });
            // How to use it, called within methods section
            // this.$store.commit('sampleFunction', payload);
        },

        getSignupForms: async (state, payload) => {
            state.signUpForms = payload
        },

        getUserSignupForm: async (state, payload) => {
            state.userSignupForm = payload
        },

        addSignUpForm: (state, payload) => {
            state.signUpForms.push(payload);
        },
        updateSignUpForm: (state, payload) => {

            state.signUpForms.map(sf => {

                if (sf.id == payload.id) {

                    sf.title = payload.title
                    sf.description = payload.description
                    sf.captcha = payload.captcha
                    sf.logo = payload.logo
                    sf.updated_at = payload.updated_at
                    sf.sign_up_form_has_custom_field = payload.sign_up_form_has_custom_field
                }

            });

        },

        deleteSignUpForm: (state, payload) => {
            state.signUpForms = state.signUpForms.filter(signUpForm => signUpForm.id !== payload);
        },
        getAllInstructors: (state, users) => {

            state.instructors = users.filter(user => user.role_assignments_instance.some(roleassignment => roleassignment.role.id == Constants.instructor));

        },
        getAllManagers: (state, users) => {

            state.managers = users.filter(user => user.role_assignments_instance.some(roleassignment => roleassignment.role.id == Constants.trainingmanager));

        },
        getAllTeamLeads: (state, users) => {

            state.teamLeads = users.filter(user => user.role_assignments_instance.some(roleassignment => roleassignment.role.id == Constants.teamlead));

        },
        getAllStudents: (state, users) => {

            state.students = users.filter(user => user.role_assignments_instance.some(roleassignment => roleassignment.role.id == Constants.student));

        },
        getAllUsers: (state, users) => {

            state.users = users;
            state.instructors = users.filter(user => user.role_assignments_instance.some(roleassignment => roleassignment.role.id == Constants.instructor));
            state.managers = users.filter(user => user.role_assignments_instance.some(roleassignment => roleassignment.role.id == Constants.trainingmanager));
            state.teamLeads = users.filter(user => user.role_assignments_instance.some(roleassignment => roleassignment.role.id == Constants.teamlead));
            state.students = users.filter(user => user.role_assignments_instance.some(roleassignment => roleassignment.role.id == Constants.student));

        },

        getAllCourses: (state, courses) => {
            state.courses = courses;
        },

        createCustomer: (state, payload) => {
            payload.customer_settings = [];
            payload.stripe_connect_account = [];
            payload.stripe_connect_active_account = null;
            state.customers.push(payload);
        },

        updateCustomer: (state, payload) => {
            let payloadParsed = JSON.parse(payload);
            state.customers.map(customer => {
                if (customer.id == payloadParsed.customerId) {
                    customer.name = payloadParsed.customer_name;
                    customer.organization_number = payloadParsed.organization_number;
                    customer.guid = payloadParsed.guid;
                    customer.phone = payloadParsed.phone;
                    customer.secret_key = payloadParsed.secret_key;
                    customer.licence = payloadParsed.licence;
                    customer.lms_url = payloadParsed.lms_url;
                    customer.address = payloadParsed.address;
                    customer.postal_code = payloadParsed.postal_code;
                    customer.city = payloadParsed.city;
                    customer.country = payloadParsed.country;
                    customer.invoice_reference = payloadParsed.invoice_reference;
                    customer.email = payloadParsed.email;
                    customer.maximum_license = payloadParsed.maximum_license;
                    customer.allow_invoice = payloadParsed.allow_invoice;
                    customer.active = payloadParsed.active;
                    customer.parent_id = payloadParsed.parent_id;
                    customer.parent_tl_id = payloadParsed.parent_tl_id;
                }

            });
        },

        updateCustomerSettings: (state, payload) => {
            state.customers.map(customer => {
                if (customer.id == payload.customer_id) {
                    if (!customer.customerSettings) {
                        customer.customerSettings = [];
                    }
                    customer.customerSettings.push(payload);
                }
            });
        },

        updateOwnCustomer: (state, payload) => {
            state.customer = payload;
        },

        getAllCustomers: (state, customers) => {
            state.customers = customers;
        },

        getOwnCustomer: (state, customer) => {
            state.customer = customer;
        },
        getProductBySlug: (state, product) => {
            state.selectedProduct = product;
        },

        getNaughtyList: (state, payload) => {
            state.naughtyList = payload;
        },

        getDomains: (state, payload) => {
            state.domains = payload;
        },

        getCustomerSubscription: (state, payload) => {
            state.customerSubscription = payload;
        },

        getUserCustomerSubscription: (state, payload) => {
            state.userCustomerSubscription = payload;
        },

        setCoupons: (state, payload) => {
            state.coupons = payload;
        },

        createGeneralSetting: (state, payload) => {
            state.generalSettings.push(payload);
        },

        getGeneralSettings: (state, payload) => {
            state.generalSettings = payload;
        },


        getSubscriptions: (state, payload) => {
            state.subscriptions = payload;
        },

        getAllSettings: (state, payload) => {
            state.generalSettings = payload;
        },

        updateGeneralSetting: (state, payload) => {
            state.generalSettings.map(setting => {
                if (setting.id == payload.id) {
                    setting.name = payload.name;
                    setting.display_name = payload.display_name;
                    setting.value = payload.value;
                    setting.type = payload.type;

                }

            });
        },

        deleteGeneralSetting: (state, payload) => {
            state.generalSettings = state.generalSettings.filter(generalSetting => generalSetting.id !== payload.id);
        },

        createStripeConnectAccount: (state, payload) => {
            state.customers.map(customer => {
                if (customer.id == payload.instance_id) {
                    customer.stripe_connect_account.push(payload);
                }
            })
        },

        updateStripeConnectAccount: (state, payload) => {
            state.customers.map(customer => {
                if (customer.customerid == payload.instance_id) {
                    customer.stripe_connect_account = customer.stripe_connect_account.map(account => {
                        if (account.id == payload.id) {
                            account = payload;
                        }
                        return account;
                    })
                }
            });

        },

        deleteStripeConnectAccount: (state, payload) => {
            state.customers.map(customer => {
                if (customer.customerid == payload.instance_id) {
                    const connectAccounts = customer.stripe_connect_account.filter(account => account.id != payload.id);
                    customer.stripe_connect_account = connectAccounts;
                }
            });
        },

        setCurrentAbandonedOrder: (state, payload) => {
            state.currentAbandonedOrder = payload;
        },

        getCompanies: (state, payload) => {
            state.companies = payload;
        },

        createCompany: (state, payload) => {
            state.companies.push(payload);
        },

        updateCompany: (state, payload) => {
            state.companies.map((company) => {
                if (company.id == payload.id) {
                    company.name = payload.updatedCompany.name;
                    company.organization_number = payload.updatedCompany.organization_number;
                    company.phone = payload.updatedCompany.phone;
                    company.address = payload.updatedCompany.address;
                    company.postal_code = payload.updatedCompany.postal_code;
                    company.city = payload.updatedCompany.city;
                    company.country = payload.updatedCompany.country;
                    company.invoice_reference = payload.updatedCompany.invoice_reference;
                    company.invoice_email = payload.updatedCompany.invoice_email;
                    company.maximum_license = payload.updatedCompany.maximum_license;
                    company.allow_invoice = payload.updatedCompany.allow_invoice;
                    company.discount = payload.updatedCompany.discount;
                    company.team_lead_userid = payload.updatedCompany.team_lead_userid;
                    company.active = payload.updatedCompany.active;
                }
            });
        }

    },
    /**
     * Action methods which calls the Back-end APIs and retrieve the data
    */
    actions: {
        post: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const data = await Api.post(payload['url'], payload['data'], payload['config']);
                store.commit("contentLoading", false);
                return data.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        get: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const data = await Api.get(payload['url'], payload['config']);
                store.commit("contentLoading", false);
                return data.data.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getRaw: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const data = await Api.get(payload['url'], payload['config']);
                store.commit("contentLoading", false);
                return data.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getAllOwnUsersCompletions: async (context) => {
            try {

                store.commit("contentLoading", true);

                let completions = context.getters.getAllOwn;

                if (completions == null) {
                    completions = await Completions.getAllOwn();
                    if (completions.data.success == true) {
                        context.commit('getAllOwn', completions.data.data);
                    }
                }

                store.commit("contentLoading", false);
                return context.getters.getAllOwn;

            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getAllOwnLicenses: async (context) => {
            try {

                store.commit("contentLoading", true);

                let licenses = context.getters.getAllOwn;

                if (licenses == null) {
                    licenses = await Licenses.getAllOwn();
                    if (licenses.data.success == true) {
                        context.commit('getAllOwn', licenses.data.data);
                    }
                }

                store.commit("contentLoading", false);
                return context.getters.getAllOwn;

            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getAllOwnCertificates: async (context) => {
            try {

                store.commit("contentLoading", true);

                let certificates = context.getters.getAllOwn;

                if (certificates == null) {
                    certificates = await Certificates.getAllOwn();
                    if (certificates.data.success == true) {
                        context.commit('getAllOwn', certificates.data.data);
                    }
                }

                store.commit("contentLoading", false);
                return context.getters.getAllOwn;

            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getSignupForms: async (context, force = false) => {

            try {

                store.commit("contentLoading", true);

                let forms = context.getters.signUpForms;

                if (forms == null || forms != null && force == true) {

                    forms = await Forms.getForms();
                    if (forms.data.success == true) {
                        context.commit('getSignupForms', forms.data.data);
                    }

                }

                store.commit("contentLoading", false);
                return context.getters.signUpForms;

            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }

        },

        getSignupFormByGuid: async (context, id) => {
            store.commit("contentLoading", true);
            let forms = await Forms.getFormByGuid(id);
            if (forms.data.success == true) {
                if (forms.data.data.length > 0) {
                    context.commit('getUserSignupForm', forms.data.data[0]);
                }

            }
            store.commit("contentLoading", false);

            return forms.data;
        },

        addSignUpForm: async (context, payload) => {

            store.commit("contentLoading", true);
            const form = await Forms.createForm(payload);
            if (form.data.success == true) {
                context.commit('addSignUpForm', form.data.data);
            }
            store.commit("contentLoading", false);
            return form.data;

        },

        updateSignUpForm: async (context, payload) => {

            store.commit("contentLoading", true);
            const form = await Forms.updateForm(payload);
            if (form.data.success == true) {
                context.commit('updateSignUpForm', form.data.data)
            }
            store.commit("contentLoading", false);
            return form.data;

        },

        deleteSignUpForm: async (context, id) => {
            store.commit("contentLoading", true);
            const result = await Forms.deleteForm(id);
            if (result.data.success == true) {
                context.commit('deleteSignUpForm', id);
            }
            store.commit("contentLoading", false);

        },

        registerUser: async (context, payload) => {

            try {
                store.commit("contentLoading", true);
                const form = await User.register(payload);
                if (form.data.success) {
                    const token = await Moodle.getToken(form.data.data.payload['token_retrieval_url']);
                    const url = form.data.data.payload['creation_url'].replace("<WS_TOKEN_HERE>", token.data.token);
                    console.log(url);

                    const config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token.data.token,
                            'Accept': 'application/json'
                        }
                    }

                    payload = JSON.stringify(form.data.data.payload['jsondata'])
                    console.log(form.data.data.payload['jsondata']);


                    payload = JSON.stringify(form.data.data.payload['jsondata'])
                    const moodleResp = await Moodle.createUser(url, { 'jsondata': payload }, config);

                    store.commit("contentLoading", false);

                    console.log(moodleResp);

                    try {

                        return JSON.parse(moodleResp.data)

                    } catch (error) {

                        return { status: "failed", message: Constants.common_error_title, error: moodleResp.data.errorcode }

                    }

                } else {
                    store.commit("contentLoading", false);
                    return form.data;
                }

            } catch (error) {
                store.commit("contentLoading", false);
                return { status: "failed", message: Constants.common_error_title, error: error }

            }

        },

        updateRegCount: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const form = await User.updateCount(payload);
                store.commit("contentLoading", false);
                return form.data;

            } catch (error) {
                store.commit("contentLoading", false);
                return { status: "failed", message: Constants.common_error_title, error: error }

            }
        },

        registerWooUsers: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const token = await Moodle.getToken(payload['token_retrieval_url']);
                const url = payload['update_url'].replace("<WS_TOKEN_HERE>", token.data.token);

                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token.data.token,
                        'Accept': 'application/json'
                    }
                }

                const moodleResp = await Moodle.createWooUsers(url, { 'jsondata': payload['payload'] }, config);

                if (moodleResp.success == true) {
                    // alert("here");
                    // context.commit('createCompany', company.data.data);
                }

                store.commit("contentLoading", false);
                return moodleResp.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        registerWebShopUser: async (context, payload) => {

            try {
                store.commit("contentLoading", true);
                const form = await User.registerWebShopUser(payload);
                if (form.data.success) {
                    const token = await Moodle.getToken(form.data.data.payload['token_retrieval_url']);
                    const userPayload = form.data.data.payload['creation_url'].replace("<WS_TOKEN_HERE>", token.data.token);


                    const config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token.data.token,
                            'Accept': 'application/json'
                        }
                    }

                    payload = JSON.stringify(payload)
                    const moodleResp = await Moodle.createUser(userPayload, { 'jsondata': payload }, config);

                    store.commit("contentLoading", false);

                    try {

                        return JSON.parse(moodleResp.data)

                    } catch (error) {

                        return { status: "failed", message: Constants.common_error_title, error: moodleResp.data.errorcode }

                    }

                } else {
                    store.commit("contentLoading", false);
                    return form.data;
                }

            } catch (error) {
                store.commit("contentLoading", false);
                return { status: "failed", message: Constants.common_error_title, error: error }

            }

        },

        loginWebShopUser: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const form = await User.loginWebShopUser(payload);
                if (form.data.success) {
                    const token = await Moodle.getToken(form.data.data.payload['token_retrieval_url']);
                    const userPayload = form.data.data.payload['login_url'].replace("<WS_TOKEN_HERE>", token.data.token);

                    const config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token.data.token,
                            'Accept': 'application/json'
                        }
                    }
                    payload = JSON.stringify(payload)
                    const moodleResp = await Moodle.loginUser(userPayload, { "jsondata": payload }, config);

                    store.commit("contentLoading", false);

                    try {

                        return JSON.parse(moodleResp.data)

                    } catch (error) {

                        return { status: "failed", message: Constants.common_error_title, error: moodleResp.data.errorcode }

                    }

                } else {
                    store.commit("contentLoading", false);
                    return form.data;
                }

            } catch (error) {
                store.commit("contentLoading", false);
                return { status: "failed", message: Constants.common_error_title, error: error }

            }

        },

        enrolExistingUser: async (context, payload) => {

            try {
                store.commit("contentLoading", true);
                const form = await User.enrolUser(payload);
                if (form.data.success) {
                    const token = await Moodle.getToken(form.data.data.payload['token_retrieval_url']);
                    const userPayload = form.data.data.payload['login_url'].replace("<WS_TOKEN_HERE>", token.data.token);

                    const config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token.data.token,
                            'Accept': 'application/json'
                        }
                    }

                    payload = JSON.stringify(payload)
                    const moodleResp = await Moodle.enrolUser(userPayload, { 'jsondata': payload }, config);

                    store.commit("contentLoading", false);

                    try {

                        return JSON.parse(moodleResp.data)

                    } catch (error) {

                        return { status: "failed", message: Constants.common_error_title, error: moodleResp.data.errorcode }

                    }

                } else {
                    store.commit("contentLoading", false);
                    return form.data;
                }

            } catch (error) {
                store.commit("contentLoading", false);
                return { status: "failed", message: Constants.common_error_title, error: error }

            }

        },

        getUsersByRoleManager: async (context) => {
            try {
                store.commit("contentLoading", true);
                let managers = context.getters.managers;
                const users = await User.getAllByRole({ 'role': "trainingmanager" });
                if (users.data.success == true) {

                    context.commit('getAllManagers', users.data.data);
                    managers = context.getters.managers

                    store.commit("contentLoading", false);
                    return managers;

                }
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        
        getUsersByRoleInstructor: async (context) => {
            try {
                store.commit("contentLoading", true);
                let instructors = context.getters.instructors;
                const users = await User.getAllByRole({ 'role': "instructor" });
                if (users.data.success == true) {

                    context.commit('getAllInstructors', users.data.data);
                    instructors = context.getters.instructors;
                }

                store.commit("contentLoading", false);
                return instructors;

            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getUsersByRoleTeamLead: async (context) => {
            try {
                store.commit("contentLoading", true);
                let teamLeads = context.getters.teamLeads;
                const users = await User.getAllByRole({ 'role': "teamlead" });
                if (users.data.success == true) {

                    context.commit('getAllTeamLeads', users.data.data);
                    teamLeads = context.getters.teamLeads;
                }

                store.commit("contentLoading", false);
                return teamLeads;

            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getUsers: async (context, force = false) => {

            try {

                store.commit("contentLoading", true);

                let users = context.getters.users;
                let managers = context.getters.managers;
                let teamLeads = context.getters.teamLeads;
                let students = context.getters.students;
                let instructors = context.getters.instructors;

                if (
                    (users == null || users != null && force == true) ||
                    (managers == null || managers != null && force == true) ||
                    (teamLeads == null || teamLeads != null && force == true) ||
                    (students == null || students != null && force == true) ||
                    (instructors == null || instructors != null && force == true)
                ) {
                    let usrs = await User.getAll();
                    if (usrs.data.success == true) {
                        context.commit('getAllUsers', usrs.data.data);
                        users = context.getters.users;
                        managers = context.getters.managers;
                        teamLeads = context.getters.teamLeads;
                        students = context.getters.students;
                        instructors = context.getters.instructors;
                    }
                }

                store.commit("contentLoading", false);

                return [users, managers, teamLeads, instructors, students];

            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }

        },

        getCourses: async (context, payload = { force: false }) => {

            try {
                // console.log(payload);

                const force = payload['force'];

                store.commit("contentLoading", true);

                let courses = context.getters.courses;

                if (courses.length == 0 || courses.length > 0 && force == true) {

                    courses = await Courses.getAll();
                    if (courses.data.success == true) {
                        context.commit('getAllCourses', courses.data.data)
                    }

                }

                store.commit("contentLoading", false);

                return context.getters.courses;

            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }

        },

        createCustomer: async (context, payload) => {

            store.commit("contentLoading", true);
            const customer = await Customers.createCustomer(payload);
            if (customer.data.success == true) {
                context.commit('createCustomer', customer.data.data);
            }
            store.commit("contentLoading", false);
            return customer.data;

        },

        updateCustomer: async (context, payload) => {

            store.commit("contentLoading", true);
            const customer = await Customers.updateCustomer(payload);
            if (customer.data.success == true) {
                context.commit('updateCustomer', payload);
            }
            store.commit("contentLoading", false);
            return customer.data;

        },

        createCustomerSettings: async (context, payload) => {

            store.commit("contentLoading", true);
            const settings = await CustomersSettings.updateOrCreate(payload);
            if (settings.success == true) {
                context.commit('updateCustomerSettings', payload);
            }
            store.commit("contentLoading", false);
            return settings;

        },

        updateOwnCustomer: async (context, payload) => {

            try {

                store.commit("contentLoading", true);
                const customer = await Customers.updateOwnCustomer(payload);
                if (customer.data.success == true) {
                    context.commit('updateOwnCustomer', payload);
                }
                store.commit("contentLoading", false);
                return customer.data;


            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }

        },

        getCustomers: async (context) => {
            store.commit("contentLoading", true);
            let customers = await Customers.getCustomers();
            if (customers.data.success == true) {
                context.commit('getAllCustomers', customers.data.data)
            }
            store.commit("contentLoading", false);
        },

        getCustomer: async (context, force = false) => {

            try {

                store.commit("contentLoading", true);

                const customer = context.getters.customer;

                if (customer == null || customer != null && force == true) {

                    let customers = await Customers.getCustomer();

                    if (customers.data.success == true) {
                        context.commit('getOwnCustomer', customers.data.data)
                    }

                }

                store.commit("contentLoading", false);

                return context.getters.customer;

            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }

        },

        getCustomerSubscription: async (context, force = false) => {
            try {

                store.commit("contentLoading", true);

                let customerSubscription = context.getters.customerSubscription
                if (customerSubscription == null || customerSubscription != null && force == true) {

                    customerSubscription = await CustomerSubscription.getOwn();
                    if (customerSubscription.data.success == true) {
                        context.commit('getCustomerSubscription', customerSubscription.data.data)
                    }

                }
                store.commit("contentLoading", false);
                return context.getters.customerSubscription;

            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getCompanySubscription: async (context, payload) => {
            try {

                store.commit("contentLoading", true);

                let companySubscription = await CustomerSubscription.getByCompany(payload);

                store.commit("contentLoading", false);
                return companySubscription.data.data;

            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getUserCustomerSubscription: async (context, force = false) => {
            try {

                store.commit("contentLoading", true);

                let userCustomerSubscription = context.getters.userCustomerSubscription;
                if (userCustomerSubscription == null || userCustomerSubscription != null && force == true) {

                    userCustomerSubscription = await UserCustomerSubscription.getAllOwn();
                    if (userCustomerSubscription.data.success == true) {
                        context.commit('getUserCustomerSubscription', userCustomerSubscription.data.data)
                    }

                }
                store.commit("contentLoading", false);
                return context.getters.userCustomerSubscription;

            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getProductBySlug: async (context, slug) => {
            store.commit("contentLoading", true);
            let product = await Product.getBySlug(slug)
            if (product.data.success == true) {
                if (product.data.data.length > 0) {
                    context.commit('getProductBySlug', product.data.data[0]);
                }

            }
            store.commit("contentLoading", false);

            return product.data;
        },

        getStripeProductById: async (context, slug) => {
            store.commit("contentLoading", true);
            let result = await StripeApi.getProductByProdyctId(slug)
            store.commit("contentLoading", false);

            return result.data;
        },

        getStripeProductPricesById: async (context, priceId) => {
            store.commit("contentLoading", true);
            let result = await StripeApi.getProductPricesByProdyctId(priceId)
            store.commit("contentLoading", false);

            return result.data;
        },

        createStripeCustomer: async (context, params) => {

            try {
                store.commit("contentLoading", true);
                let result = await StripeApi.createCustomer(params)
                store.commit("contentLoading", false);

                return result.data;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }

        },

        createStripeConnectedAccountCustomer: async (context, params) => {

            try {
                store.commit("contentLoading", true);
                let result = await StripeApi.createConnectedAccountCustomer(params)
                store.commit("contentLoading", false);

                return result.data;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }

        },

        createStripeSubscription: async (context, params) => {

            try {

                store.commit("contentLoading", true);
                let result = await StripeApi.createSubscription(params)
                store.commit("contentLoading", false);

                return result.data;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }

        },

        getStripePaymentMethods: async (context, params) => {

            try {
                store.commit("contentLoading", true);
                let result = await StripeApi.getStripePaymentMethods(params)
                store.commit("contentLoading", false);

                return result.data;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }
        },

        attachPaymentMethodToCustomer: async (context, params, paymentMethod) => {

            try {
                store.commit("contentLoading", true);
                let result = await StripeApi.attachPaymentMethodToCustomer(params, paymentMethod)
                store.commit("contentLoading", false);

                return result.data;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }
        },

        createStripeInvoiceItem: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                let invoiceItem = await StripeApi.createStripeInvoiceItem(payload);
                store.commit("contentLoading", false);
                return invoiceItem;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }
        },

        createStripeInvoice: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                let invoice = await StripeApi.createStripeInvoice(payload);
                store.commit("contentLoading", false);
                return invoice;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }
        },

        sendStripeInvoiceForPayment: async (context, invoiceId) => {

            try {
                store.commit("contentLoading", true);
                let session = await StripeApi.sendStripeInvoiceForPayment(invoiceId);
                store.commit("contentLoading", false);
                return session;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }
        },

        createStripeCheckoutSession: async (context, params) => {
            try {
                store.commit("contentLoading", true);
                let session = await Customers.createCustomerCheckoutSession(params);
                store.commit("contentLoading", false);

                return session.data;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }
        },

        getStripeCheckoutSession: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                let session = await StripeApi.getStripeCheckoutSession(payload);
                store.commit("contentLoading", false);

                return session.data;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }
        },

        getStripePaymentIntent: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                let paymentIntent = await StripeApi.getPaymentIntent(payload);
                store.commit("contentLoading", false);

                return paymentIntent;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }
        },

        createWebshopStripeCheckoutSession: async (context, params) => {
            try {
                store.commit("contentLoading", true);
                let session = await Customers.createWebshopCheckoutSession(params);
                store.commit("contentLoading", false);

                return session.data;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }
        },

        getStripeSubscriptionById: async (context, subscriptionId) => {
            try {
                store.commit("contentLoading", true);
                let session = await StripeApi.getStripeSubscriptionById(subscriptionId);
                store.commit("contentLoading", false);

                return session.data;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }
        },


        // getStripeCheckoutSession: async (context, params) => {
        //     try {
        //         store.commit("contentLoading", true);
        //         let session = await Customers.getCustomerCheckoutSession(params.id);
        //         store.commit("contentLoading", false);

        //         return session.data;

        //     } catch (error) {

        //         store.commit("contentLoading", false);
        //         throw error;

        //     }
        // },

        getNaughtyList: async (context) => {

            try {
                let naughtyList = [].concat(...Object.values(words))
                naughtyList = naughtyList.map(s => s.replace(/ +/g, ""));
                context.commit('getNaughtyList', naughtyList);

                return naughtyList;

            } catch (error) {

                store.commit("contentLoading", false);
                throw error;

            }
        },

        getDomains: async (context) => {
            store.commit("contentLoading", true);
            let domains = await Customers.getDomains();
            if (domains.data.success == true) {
                if (domains.data.data.length > 0) {

                    const dl = domains.data.data;
                    context.commit('getDomains', dl);
                }

            }
            store.commit("contentLoading", false);

            return context.getters.getDomains;
        },

        createCustomerInstance: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const customerInstance = await CustomerInstance.createInstance(payload)
                store.commit("contentLoading", false);
                return customerInstance.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        updateWebShop: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const result = await WebShop.update(payload)
                store.commit("contentLoading", false);
                return result.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        readAllOwnWebShop: async (context, payload) => {
            try {

                store.commit("contentLoading", true);

                const result = await WebShop.readallown(payload)
                store.commit("contentLoading", false);
                return result.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        readAllWebShop: async (context, payload) => {
            try {

                store.commit("contentLoading", true);

                const result = await WebShop.readall(payload)
                store.commit("contentLoading", false);
                return result.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        createWebshopPayment: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const webshopPayment = await WebShopPayment.create(payload);
                store.commit("contentLoading", false);
                return webshopPayment.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        updateWebshopPayment: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const webshopPayment = await WebShopPayment.update(payload);
                store.commit("contentLoading", false);
                return webshopPayment.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getAllOwnWebshopPayment: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const webshopPayment = await WebShopPayment.getAllOwn(payload);
                store.commit("contentLoading", false);
                return webshopPayment.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        approveWebshopPayment: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const webshopPayment = await WebShopPayment.approve(payload);
                store.commit("contentLoading", false);
                return webshopPayment.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        declineWebshopPayment: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const webshopPayment = await WebShopPayment.decline(payload);
                store.commit("contentLoading", false);
                return webshopPayment.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getpendingWebshopPayment: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const webshopPayment = await WebShopPayment.getpendingpayment(payload);
                context.commit('setCurrentAbandonedOrder', webshopPayment.data.data)

                store.commit("contentLoading", false);
                return webshopPayment.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        createWebshopPaymentInquiry: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const result = await WebShopPayment.notify(payload);
                store.commit("contentLoading", false);
                return result.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        createWebshopPaymentCharge: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const webshopPayment = await WebShopPaymentCharge.create(payload);
                store.commit("contentLoading", false);
                return webshopPayment.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getWebshopCourse: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const webshopCourse = await WebShop.getCourse(payload);
                store.commit("contentLoading", false);
                return webshopCourse.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        createCoupon: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const result = await Coupon.create(payload);
                store.commit("contentLoading", false);
                return result.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getAllCoupons: async (context) => {
            try {
                store.commit("contentLoading", true);
                const result = await Coupon.getAllOwn();

                if (result.data.success == true) {
                    if (result.data.data.length > 0) {
                        context.commit('setCoupons', result.data.data);
                    }
                }

                store.commit("contentLoading", false);
                return context.getters.coupons;

            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        createGeneralSetting: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const setting = await Settings.create(payload);
                if (setting.data.success == true) {
                    context.commit('createGeneralSetting', setting.data.data);
                }
                store.commit("contentLoading", false);
                return setting.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getGeneralSettings: async (context) => {
            try {
                store.commit("contentLoading", true);
                let setting = await Settings.get();
                if (setting.data.success == true) {
                    context.commit('getGeneralSettings', setting.data.data)
                }
                store.commit("contentLoading", false);
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getAllSettings: async (context) => {
            try {
                let settings = await Settings.getAll();
                if (settings.data.success == true) {
                    context.commit('getAllSettings', settings.data.data)
                }
                return settings.data.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }

        },
        updateGeneralSetting: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const setting = await Settings.update(payload);
                if (setting.data.success == true) {
                    context.commit('updateGeneralSetting', setting.data.data);
                }
                store.commit("contentLoading", false);
                return setting.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        deleteGeneralSetting: async (context, payload) => {

            store.commit("contentLoading", true);
            const setting = await Settings.delete(payload);
            if (setting.data.success == true) {
                context.commit('deleteGeneralSetting', setting.data.data);
            }
            store.commit("contentLoading", false);
            return setting.data;

        },

        getActiveOnboardedStripeConnectAccount: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const account = await StripeConnectAccount.getActiveOnboarded(payload);
                store.commit("contentLoading", false);
                return account.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        createStripeConnectAccount: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const account = await StripeConnectAccount.create(payload)
                if (account.data.success == true) {
                    context.commit('createStripeConnectAccount', account.data.data);
                }
                store.commit("contentLoading", false);
                return account.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        updateStripeConnectAccount: async (context, payload) => {

            try {
                store.commit("contentLoading", true);
                const account = await StripeConnectAccount.update(payload);
                if (account.data.success == true) {
                    context.commit('updateStripeConnectAccount', account.data.data);
                }
                store.commit("contentLoading", false);
                return account.data;
            } catch (error) {

                store.commit("contentLoading", false);
                return Common.handleRequestValidators(error);

            }

        },

        deleteStripeConnectAccount: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const account = await StripeConnectAccount.delete(payload);
                if (account.data.success == true) {
                    context.commit('deleteStripeConnectAccount', account.data.data);
                }
                store.commit("contentLoading", false);
                return account.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        createAccountLink: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const link = await Stripe.createAccountLink(payload);
                store.commit("contentLoading", false);
                return link.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        createStripePaymentIntent: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const intent = await Stripe.createPaymentIntent(payload);
                store.commit("contentLoading", false);
                return intent.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        createStripeCheckout: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const session = await Stripe.createCheckoutSession(payload);
                store.commit("contentLoading", false);
                return session.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        retrieveUser: async (context,) => {
            try {
                store.commit("contentLoading", true);
                const user = await User.retrieve();

                const data = user.data;

                if (data && data.success == true) {
                    if (data && data.data.token && data.data.user) {

                        localStorage.setItem('token', data.data.token);
                        context.commit('setAuthUser', data.data.user);
                    }
                }

                store.commit("contentLoading", false);
                return user.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getInstanceSettingsFiltered: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const settings = await Settings.getFiltered(payload);
                store.commit("contentLoading", false);
                return settings.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        createCoursesEventInquiry: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const result = await CoursesEventInquiry.notify(payload);
                store.commit("contentLoading", false);
                return result.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        courseAssignmentEnrolled: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const result = await CourseAssignment.enrolled(payload);
                store.commit("contentLoading", false);
                return result.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        userGetFirst: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const user = await User.getFirst(payload);
                store.commit("contentLoading", false);
                return user.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        companyGetAllOwn: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const company = await Company.getAllOwn(payload);
                if (company.data.success == true) {
                    context.commit('getCompanies', company.data.data);
                }
                store.commit("contentLoading", false);
                return company.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        companyGetFirst: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const company = await Company.getFirst(payload);
                store.commit("contentLoading", false);
                return company.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        companyCreate: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const token = await Moodle.getToken(payload['token_retrieval_url']);
                const url = payload['creation_url'].replace("<WS_TOKEN_HERE>", token.data.token);

                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token.data.token,
                        'Accept': 'application/json'
                    }
                }

                const moodleResp = await Moodle.createCompany(url, { 'jsondata': payload['payload'] }, config);

                //const company = await Company.create(payload);
                if (moodleResp.success == true) {
                    // alert("here");
                    // context.commit('createCompany', company.data.data);
                }

                store.commit("contentLoading", false);
                return moodleResp.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        companyUpdate: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const token = await Moodle.getToken(payload['token_retrieval_url']);
                const url = payload['update_url'].replace("<WS_TOKEN_HERE>", token.data.token);


                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token.data.token,
                        'Accept': 'application/json'
                    }
                }

                const moodleResp = await Moodle.updateCompany(url, { 'jsondata': payload['payload'] }, config);
                store.commit("contentLoading", false);
                return moodleResp.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        getCompanyOrders: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const orders = await WebShopPayment.getOrders(payload);
                store.commit("contentLoading", false);
                return orders.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        subscriptionRead: async (context) => {
            try {
                store.commit("contentLoading", true);
                const subs = await Subscription.readall();

                if (subs.data.success == true) {
                    context.commit('getSubscriptions', subs.data.data)
                }

                store.commit("contentLoading", false);
                return subs.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },

        createTemporaryWebshopPayment: async (context, payload) => {
            try {
                store.commit("contentLoading", true);
                const webshopPayment = await TemporaryWebshopOrder.create(payload);
                store.commit("contentLoading", false);
                return webshopPayment.data;
            } catch (error) {
                store.commit("contentLoading", false);
                throw error;
            }
        },



    },
})